/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S2_Li4Inputs */

const en_guide_json_schema_s2_li4 = /** @type {(inputs: Guide_Json_Schema_S2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>items</strong>: Defines the schema for array elements`)
};

const ko_guide_json_schema_s2_li4 = /** @type {(inputs: Guide_Json_Schema_S2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>items</strong>: 배열 요소에 대한 스키마를 정의`)
};

const ja_guide_json_schema_s2_li4 = /** @type {(inputs: Guide_Json_Schema_S2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>items</strong>: 配列要素のスキーマを定義`)
};

/**
* | output |
* | --- |
* | "<strong>items</strong>: Defines the schema for array elements" |
*
* @param {Guide_Json_Schema_S2_Li4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s2_li4 = /** @type {((inputs?: Guide_Json_Schema_S2_Li4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S2_Li4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s2_li4(inputs)
	if (locale === "ko") return ko_guide_json_schema_s2_li4(inputs)
	return ja_guide_json_schema_s2_li4(inputs)
});